import { render, staticRenderFns } from "./CodemirrorModeMenu.vue?vue&type=template&id=304c2498"
import script from "./CodemirrorModeMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CodemirrorModeMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports